(() => {
  const initEsenceMotion = () => {
    const sections = document.querySelectorAll('.esence-experience');
    if (!sections.length || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    sections.forEach((section) => {
      section.classList.add('esence-reveal-ready');
      observer.observe(section);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEsenceMotion, { once: true });
  } else {
    initEsenceMotion();
  }
  document.addEventListener('shopify:section:load', initEsenceMotion);
})();